import { getEndpoint } from '../endpoints';
import { workflowFields } from '../../utils/workflowFields';

export const workflow = {
    state: {
        workflowForm: {
            ...workflowFields,
        },
        nextStatuses: [],
        workflows: null,
        timeline: null,
    },
    getters: {
        getWorkflowForm(state) {
            return state.workflowForm;
        },
        getNextStatuses(state) {
            return state.nextStatuses;
        },
    },
    actions: {
        async fetchNextStatuses({ rootState, commit }) {
            const endpoint = getEndpoint('workflow', null, rootState.route.params.controlId).nextStatuses;
            const { data } = await rootState.app.http.instance.get(endpoint);

            commit('setNextStatuses', data);
        },
        async fetchWorkflows({ rootState, commit }) {
            const endpoint = getEndpoint('workflow', null, rootState.route.params.controlId).status;
            const { data } = await rootState.app.http.instance.get(endpoint);

            commit('setWorkflows', data);
        },
        async fetchTimeline({ rootState, commit }) {
            const endpoint = getEndpoint('workflow', null, rootState.route.params.controlId).timeline;
            const { data } = await rootState.app.http.instance.get(endpoint);

            commit('setTimeline', data);
        },
        async submitWorkflow({ rootState, dispatch, commit, state }) {
            let formData = new FormData();
            const endpoint = getEndpoint('workflow', null, rootState.route.params.controlId).changeStatus;
            commit('addExtratFieldsToFormWorkflow');

            formData.append('data', JSON.stringify(state.workflowForm));
            await rootState.app.http.instance
                .post(endpoint, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(
                    response => {
                        commit('setNotif', response);
                        dispatch('redirectToDetail');
                    },
                    () => {
                        commit('setNotif');
                        dispatch('redirectToDetail');
                    }
                );
        },
        handleSubmitWorkflow({ dispatch }) {
            dispatch('submitWorkflow');
        },
        initWorkflowForm({ commit }) {
            commit('initFormWorkflow');
        },
    },
    mutations: {
        setWorkflowForm(state, payload) {
            Object.entries(payload).map(([key, val]) => {
                if (val && typeof val === 'object' && val.constructor === Object) {
                    if (typeof val.id !== 'undefined') {
                        payload[key] = val.id;
                    }
                }
            });

            state.workflowForm = payload;
        },
        initFormWorkflow(state) {
            state.workflowForm = { ...workflowFields };
        },
        addExtratFieldsToFormWorkflow(state) {
            state.workflowForm.applicationUser = null;
        },
        setNextStatuses(state, payload) {
            state.nextStatuses = payload;
        },
        setWorkflows(state, payload) {
            state.workflows = payload;
        },
        setTimeline(state, payload) {
            state.timeline = payload;
        },
    },
};
